<template lang="pug">
v-app(dark)
  header
    v-navigation-drawer(:clipped="clipped" v-model="drawer" fixed app disable-resize-watcher)
      v-list(v-for="item in items" :key="item" style="padding:0;")
        v-list-tile(:href="item.url" value="true")
          v-list-tile-actions
            i(:class="item.class")
          v-list-tile-content
            v-list-tile-title(v-text="item.title")
        v-divider(v-if="item.divide == true")
          hr.grey.darken-1
    v-toolbar(app :clipped-left="clipped" height="40px")
      v-toolbar-side-icon(@click.stop="drawer = !drawer")
      v-toolbar-title.subheading(v-text="title")
      v-spacer
      v-btn(icon :href="twitter" target="_blank")
        i.fab.fa-twitter
  article(style="padding-top:0px;")
    v-content
      router-view
  footer
    v-footer(absolute)
      v-container.copyright(text-xs-center)
        p &copy; 2014 - 2018 Tsuruhashi Records
</template>

<script>
import Home from './views/Home'
 
export default {
  name: 'App',
  components: {
    Home
  },
  data () {
    return {
      twitter: "https://twitter.com/intent/tweet?text=Tsuruhashi Recordsは「ミュージックカルチャーの開拓・再発掘」をテーマとしたジャンルフリー、メンバー不定のネットレーベルです。&hashtags=ツルレコ&url=" + encodeURIComponent(location.href),
      clipped: true,
      drawer: false,
      items: [
        {
          class: 'fas fa-home',
          title: 'Top',
          url: '/',
          divide: false
        },
        {
          class: 'fas fa-user',
          title: 'About',
          url: '/about',
          divide: false
        },
        {
          class: 'fas fa-envelope',
          title: 'Contact',
          url: '/contact',
          divide: true
        },
        {
          class: 'fas fa-music',
          title: 'Release',
          url: '/release',
          divide: false
        },
        {
          class: 'fas fa-crown',
          title: 'Wanted',
          url: '/wanted',
          divide: true
        },
        {
          class: 'fab fa-twitter',
          title: 'Twitter',
          url: 'https://twitter.com/tsuruhashi_rec',
          divide: false
        },
        {
          class: 'fab fa-soundcloud',
          title: 'SoundCloud',
          url: 'https://soundcloud.com/tsuruhashi-records',
          divide: false
        },
        {
          class: 'fab fa-youtube',
          title: 'Youtube',
          url: 'https://www.youtube.com/channel/UCuYNr2VNqD1JBcnX3RRlQlA',
          divide: false
        }
      ],
      title: 'Tsuruhashi Records'
    }
  }
}
</script>

<style lang="scss" scoped>
i {
  display: inline-block;
  width: 3em;
  font-size: 1em;
  text-align: center;
}
.copyright {
  padding-top: 0.2em;
  padding-bottom: 0;
  p {
    margin: 0;
    padding: 0;
  }
}
</style>
